import { useState } from "react";

/* eslint-disable react/no-unescaped-entities */
interface WebsiteProps {
    url: string;
}

const Website:React.FC<WebsiteProps> = ({ url }) =>  {
    const [isLoading, setLoading] = useState(true);

    return (
        <div className="fade-transition m-1">
            <div className="text-center my-1">
                <h1 className="primary-color bold">Welcome! An-Nur Info-Tech Preview</h1>
                <p className="fs-14">
                    Here's a live preview of my services website - <a href="https://an-nur-info-tech.com" className="primary-color" target="_blank" rel="noopener noreferrer"> an-nur-info-tech.com </a>.
                    It’s built with Laravel and includes cool stuff like a blog, interactive quizzes, code editors, and more.
                    Feel free to look around!
                </p>
            </div>
            
            {isLoading && (
                <div className="text-center mt-5">
                    <span className="loader" />
                    <p> Loading website preview ...</p>
                </div>
            )}

            <iframe 
                src={url}
                title="Website Preview"
                width="100%"
                height="800"
                style={{ 
                    borderRadius: '5px',
                    display: isLoading ? 'none' : 'block'
                }} 

                onLoad={() => setLoading(false)}
            />
        </div>
    );
}

export default Website;